export default __webpack_public_path__ + "static/media/04.5adaa283.jpg";